<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('Verify work bundle users') }}
    </h1>
    <InfoBar>
      <span class="pt-1 flex-1 text-white text-justify text-base">
        {{ $t('unAuthorizedMohreUsersNote') }}
      </span>
    </InfoBar>

    <DataTable :data-set="dataSet">
      <template #headerCell="{ label }">
        <span v-if="label == 'selector'">&nbsp;</span>
        <span v-else>
          {{ $t(label) }}
        </span>
      </template>
      <template #cell="{ columnName, columnValue, rowIndex }">
        <div v-if="columnName == 'selector'" class="w-full h-full flex gap-1">
          <div class="w-full flex justify-center">
            <button
              :class="[
                selectedUser?.rowIndex == rowIndex ? 'border-primary' : 'border-brand-gray-600'
              ]"
              class="flex justify-center items-center border border-brand-gray-600 rounded-full size-3.5"
              @click="onRowClick(rowIndex)"
            >
              <div
                :class="[selectedUser?.rowIndex == rowIndex ? 'bg-primary' : '']"
                class="rounded-full size-2"
              ></div>
            </button>
          </div>
        </div>
      </template>
    </DataTable>
    <div class="w-full flex">
      <button
        v-if="selectedUser"
        class="px-4 py-1 text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
        @click="onSendOtp"
      >
        {{ $t('sendOtp') }}
      </button>
    </div>

    <ModalVue
      :title="$t('Verify work bundel users')"
      v-model="otpModal"
      container-class="relative w-[24rem] md:w-[32rem] max-h-[70vh]"
    >
      <template #body>
        <OtpForm :user="selectedUser" @on-verified="onVerifiedUser"></OtpForm>
      </template>
      <template #footer>&nbsp;</template>
    </ModalVue>
  </div>
</template>

<script setup>
import axiosInstance from '@/services'
import { onMounted, ref, computed } from 'vue'
import InfoBar from '@/components/Form/InfoBar.vue'
import DataTable from '@/components/DataTable/index.vue'
import { notify } from 'notiwind'
import { useI18n } from 'vue-i18n'
import ModalVue from '@/components/Ui/Modal/index.vue'
import OtpForm from '@/views/establishment/validate-subusers/OtpForm.vue'

const i18n = useI18n()

const otpModal = ref(false)
const isLoading = ref(true)
const workBundleUsers = ref([])
const selectedUser = ref()

const dataSet = computed(() => {
  if (workBundleUsers.value.length === 0) return

  return workBundleUsers.value.map((w) => {
    return {
      selector: '',
      'Authorizer Arabic Name': w.personNameArb,
      'Authorizer English Name': w.personNameEng,
      receiverMobile: w.mobileNo
    }
  })
})

onMounted(async () => {
  await fetchData()
})

async function fetchData() {
  isLoading.value = true
  workBundleUsers.value = await axiosInstance.get('/api/establishment/mohreWorkPackage/draft/users')
  isLoading.value = false
}

function onRowClick(rowIndex) {
  const user = workBundleUsers.value[rowIndex]
  const { isWrongMobileNumber = false, isWrongMohreUserId = false, isWrongEida = false } = user

  const messages = []

  let counter = 0

  if ([isWrongMobileNumber, isWrongMohreUserId, isWrongEida].some((x) => x)) {
    if (isWrongMobileNumber) {
      counter += 1
      messages.push([counter, 'Missing Mobile Number'].join('. '))
    }

    if (isWrongMohreUserId) {
      counter += 1
      messages.push([counter, 'Missing mohre user Id'].join('. '))
    }

    if (isWrongEida) {
      counter += 1
      messages.push([counter, 'Person identity Number'].join('. '))
    }

    if (messages.length > 0) {
      messages.push('Please contact MOHRE')
    }

    notify(
      {
        group: 'error',
        title: i18n.t('There is data error'),
        body: messages.join('<br/>')
      },
      1000 * 12
    )

    return
  }

  selectedUser.value = {
    ...user,
    rowIndex
  }
}

async function onSendOtp() {
  otpModal.value = true
}

function onVerifiedUser() {
  // TODO: blocked. serviceTransactionId is not in query
}
</script>

<style lang="scss" scoped></style>
